var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonPinCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0V0C31.0457 0 40 8.9543 40 20V20C40 31.0457 31.0457 40 20 40V40C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10H13C11.89 10 11 10.9 11 12V26C11 27.1 11.89 28 13 28H17L20 31L23 28H27C28.1 28 29 27.1 29 26V12C29 10.9 28.1 10 27 10ZM27 26H22.17L21.58 26.59L20 28.17L18.41 26.58L17.83 26H13V12H27V26ZM20 19C21.65 19 23 17.65 23 16C23 14.35 21.65 13 20 13C18.35 13 17 14.35 17 16C17 17.65 18.35 19 20 19ZM20 15C20.55 15 21 15.45 21 16C21 16.55 20.55 17 20 17C19.45 17 19 16.55 19 16C19 15.45 19.45 15 20 15ZM26 23.58C26 21.08 22.03 20 20 20C17.97 20 14 21.08 14 23.58V25H26V23.58ZM16.48 23C17.22 22.49 18.71 22 20 22C21.29 22 22.78 22.49 23.52 23H16.48Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPinCircle40Px);
export default __webpack_public_path__ + "static/media/person_pin_circle-40px.52b0f09cc55bf5cd2c71462163c3a678.svg";
export { ForwardRef as ReactComponent };